import { useParams, useSearchParams } from 'react-router-dom';

import TasksBoard from '../../features/work/layouts/board';
import TaskDetail from '../../features/work/layouts/detail';
import WorkQueue from '../../features/work/layouts/queue';

export default function WorkPage() {
    const { taskId } = useParams();
    const [params] = useSearchParams();
    const id = Number(taskId);
    if (taskId) return <TaskDetail key={id} taskId={Number.isInteger(id) && id > 0 ? id : 0} />;
    return params.get('vista') === 'lista' ? <WorkQueue /> : <TasksBoard />;
}
